module.exports = __webpack_public_path__ + "img/searching.2d714a3.png";